import React, { FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import { Section, SectionIcon, SectionLabel, Wrapper } from './CompanyCourses.elements';

interface CompanyCoursesProcessProps {}

const CompanyCoursesProcessTemplate: FC<CompanyCoursesProcessProps> = () => {
    const { t } = useTranslation();

    return (
        <ContentWrapper mobileSidePadding={20}>
            <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                {t('companyCourses.process.title')}
            </TitleTemplate>
            <Wrapper>
                <Section>
                    <SectionIcon name={Icons.Zoom} />
                    <SectionLabel dangerouslySetInnerHTML={{ __html: t('companyCourses.process.section1.label') }} />
                </Section>
                <Section>
                    <SectionIcon name={Icons.Calendar} />
                    <SectionLabel dangerouslySetInnerHTML={{ __html: t('companyCourses.process.section2.label') }} />
                </Section>
                <Section>
                    <SectionIcon className="board" name={Icons.Board} />
                    <SectionLabel dangerouslySetInnerHTML={{ __html: t('companyCourses.process.section3.label') }} />
                </Section>
                <Section>
                    <SectionIcon className="feedback" name={Icons.Feedback} />
                    <SectionLabel dangerouslySetInnerHTML={{ __html: t('companyCourses.process.section4.label') }} />
                </Section>
            </Wrapper>
        </ContentWrapper>
    );
};
export default CompanyCoursesProcessTemplate;
